import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps, IItemCardButtonsProps } from 'models/itemcard';
import * as c from 'models/constants';
import { ItemCardButtons } from 'components';
import { ISelectorItem } from 'models/common';
import { formatCurrency, imgSrcAttributes } from 'helpers/common';

require('./style.css');

interface IProps extends IItemCardProps {
	item: ISelectorItem;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class SelectorItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.removeItem = this.removeItem.bind(this);
	}

	public removeItem(e: any) {
		e.cancelBubble = true;
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		if (this.props.removeItem) {
			this.props.removeItem(this.props.item.order);
		}
	}

	public render() {
		const { picture, name, addedBy, price, originalPrice, shopCurrencyKey } = this.props.item;

		const itemCardButtonsProps: IItemCardButtonsProps = {
			removeItem: this.props.removeItem ? this.removeItem : null,
		};
		if (price) {
			return (
				<div className="col-12 col-sm-6 col-md-3 col-lg-12 col-xl-6 selectorItemCard">
					<div className="itemHolder">
						<div className="imageHolder">
							<img {...imgSrcAttributes(picture)} className="image" />
						</div>
						<div className="itemDetail">
							<div className="top">
								<span className="shopName">{addedBy}</span>
								<div className="clear" />
							</div>
							<div className="bottom">
								<div className="name">{name}</div>
								<div className="productPrice">
									<span className="amount">{formatCurrency(shopCurrencyKey, price)}</span>
									{originalPrice > price ? (
										<label className="salePrice">{formatCurrency(shopCurrencyKey, originalPrice)}</label>
									) : null}
								</div>
								<div className="clear" />
							</div>
						</div>
						<ItemCardButtons {...itemCardButtonsProps} />
					</div>
				</div>
			);
		} else {
			return (
				<div className="col-12 col-sm-6 col-md-3 col-lg-12 col-xl-6 selectorItemCard">
					<div className="itemHolder">
						<div className="imageHolder">
							<img {...imgSrcAttributes(picture)} className="image" />
						</div>
						<div className="itemDetail">
							<div className="top">
								<span className="shopName">{addedBy}</span>
								<div className="clear" />
							</div>
							<div className="bottom">
								<div className="name">{name}</div>
								<div className="clear" />
							</div>
						</div>
						<ItemCardButtons {...itemCardButtonsProps} />
					</div>
				</div>
			);
		}
	}
}

export { SelectorItemCard };
